import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-warning-dialog-moha',
  templateUrl: './warning-dialog-moha.component.html'
})
export class WarningDialogMohaComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<WarningDialogMohaComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
